import { takeLatest } from 'redux-saga/effects';
import { fetchTask, taskCollection } from 'collections/tasks';
import { logger } from 'services';
import { fetchTaskSaga } from '../actions';
function* getTaskByIdSaga(action) {
    const { projectId, taskId, onSuccess } = action.payload;
    try {
        const task = yield fetchTask(projectId, taskId);
        /* when get DELETED task, backend will return 204: no content. So adding condition for safety */ if (task) {
            if (onSuccess) {
                onSuccess(task);
            }
            taskCollection.push([
                task
            ]);
        }
    } catch (error) {
        logger.error('getTaskByIdSaga failed', {
            error
        });
    }
}
export const watchGetTaskByIdSaga = function*() {
    yield takeLatest(fetchTaskSaga.type, getTaskByIdSaga);
};
